var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionZentriertControl(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.37,3.29H1.63A1.65,1.65,0,0,1,1.63,0H40.37a1.65,1.65,0,0,1,0,3.29Zm-5.55,9.26a1.64,1.64,0,0,0-1.64-1.65H8.82a1.65,1.65,0,0,0,0,3.29H33.18A1.63,1.63,0,0,0,34.82,12.55ZM42,23.45a1.63,1.63,0,0,0-1.63-1.64H1.63a1.65,1.65,0,0,0,0,3.29H40.37A1.64,1.64,0,0,0,42,23.45ZM37.91,34.36a1.64,1.64,0,0,0-1.64-1.65H5.72a1.65,1.65,0,0,0,0,3.29H36.27A1.64,1.64,0,0,0,37.91,34.36Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionZentriertControl);
export default __webpack_public_path__ + "static/media/tredition-zentriert-control.b528afcd1d7f19b793a22f97a802587a.svg";
export { ForwardRef as ReactComponent };